import {Component} from '@angular/core';
import {AutoUnsubscribe} from 'src/infrastructure/decorators/auto-unsubscribe.decorator';
import {GenericChartComponent} from '../generic-chart/generic-chart.component';
import {FinanceDashboardChartType} from '../../enum/FinanceDashboardChartType';
import {SubmitToPieChartColorOptionsArray} from '../../constants/finance-dashboard-chart-options';

@Component({
    selector: 'app-commission-by-submit-to',
    templateUrl: './commission-by-submit-to.component.html',
    standalone: false
})

@AutoUnsubscribe()
export class CommissionBySubmitToComponent extends GenericChartComponent {
  constructor() {
    super();
    this.chartConfiguration = {
      title: 'Commission by Submit To',
      chartType: FinanceDashboardChartType.Pie,
      backGroundColor: SubmitToPieChartColorOptionsArray,
      borderColor: SubmitToPieChartColorOptionsArray,
    };
  }
}
